import { Button, Text } from "../UI";
import { useTheme } from "styled-components";
import Modal from "../UI/Modal";
import { useTranslation } from "react-i18next";

const ConfirmModal = ({ title, text, onClose, handleAction }) => {
  const { t } = useTranslation("common");
  const theme = useTheme();

  return (
    <Modal onClose={() => onClose(false)}>
      <div
        style={{
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ marginBottom: 5 }}>
          <Text.H2 color={theme.color.label}>{title}</Text.H2>
        </div>
        <div>
          <Text> {text} </Text>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 5,
          }}
        >
          <Button
            onClick={(e) => handleAction(e)}
            buttonStyle="main"
            style={{ marginTop: 30, width: 140 }}
          >
            {t("yes")}
          </Button>
          <Button
            onClick={() => onClose()}
            buttonStyle="border-linear"
            style={{ marginTop: 30, width: 140 }}
          >
            {t("no")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
